import React from 'react';

const ClayBackground = ({ children, className = "", opacity = 0.5 }) => {
    const backgroundStyle = {
        backgroundImage: `linear-gradient(rgba(250, 249, 247, ${opacity}), rgba(250, 249, 247, ${opacity})), url('/images/rockyWall.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
    };

    return (
        <section style={backgroundStyle} className={`relative ${className}`}>
            <div className="relative z-10">
                {children}
            </div>
        </section>
    );
};

export default ClayBackground;